import cookie from 'js-cookie'
import { EnterPatCallout } from '../components/EnterPatCallout'
import { PAT_KEY, config } from '../shared'

type Props = {
  children: React.ReactNode
}

export const PatProvider = ({ children }: Props) => {
  const pat = cookie.get(PAT_KEY)

  if (config.usePat && !pat) {
    return <EnterPatCallout />
  }

  return <>{children}</>
}
